/*  This is a react hooks style form that uses plaid */
import React, { useState } from 'react';
import AbEnvironment from '../auth/AbEnvironment';
import { usePlaidLink } from 'react-plaid-link';
import LoadingSpinner from '../ui/LoadingSpinner';


const abEnvironment = new AbEnvironment();

const ACHFormIIPlaidOAuth = (props) => {
  const [token, setToken] = useState({  });

  // get link_token from your server when component mounts
  React.useEffect(() => {
    const createLinkToken = async () => {

      //console.log('setting up form');
      //console.log(pcId);
      //console.log(localStorage.getItem('plaid'))
      if (localStorage.getItem('plaid')) {
        let data = JSON.parse(localStorage.getItem('plaid'));
        setToken(data.plaidtoken.link_token);

        //console.log('got link token->' + data.plaidtoken.link_token);
        //console.log(window.location.href);

      } 

    };
    createLinkToken();
  }, [props]);


  const onSuccess = (publicToken, metadata) => {
    // send public_token to your server
    // https://plaid.com/docs/api/tokens/#token-exchange-flow
 
    //console.log(publicToken)
    //console.log(JSON.stringify(metadata));
   
    const { callPartnerApi } = props.auth;
  
    let acctId          = props.dAccountId;
    let account         = metadata.account;
    let accounts        = metadata.accounts;
    let institution     = metadata.institution;

    let aPjwt = abEnvironment.getPjwt();

    // Call server side to connect account
    let payload = {
      operation: "connectPlaidAccountToDwolla",
      params: {
        pJwt:         aPjwt,
        accountId:    acctId,
        dcId:         props.pcId,
        institution:  institution,
        account:      account,
        accounts:     accounts,
        publicToken:  publicToken,
        firstName:    props.dFirstName,
        lastName:     props.dLastName,
        email:        props.dEmail,
        paymentOrder: props.porder
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    ).then(resp => {
      return resp.json();
    }).then(data => {
      //localStorage.removeItem('plaid');

      let returnData = JSON.parse(data);

      if (returnData.data && returnData.data.createPaymentSourceT && returnData.data.createPaymentSourceT.paymentSourceT && returnData.data.createPaymentSourceT.paymentSourceT.psId != null) {

        localStorage.removeItem('plaid')
        var paymentReturn = localStorage.getItem('paymentReturn');
        if (paymentReturn) {
          props.onClose();  //try to eliminate hurky jerky
          localStorage.removeItem('paymentReturn');
          props.history.push (paymentReturn);
          window.location.reload();
        } else {
          window.location.reload();
          props.onClose();
        }

      }

    }).catch(reason => {
      // console.log('Failure in plaid setup: ' + reason);
    });    


  };

  const onExit = (publicToken, metadata) => {
    // did not complete the task, close
    props.onClose();
  };

  const onEvent = (eventName, metadata) => {
    //console.log(eventName);
    //no op
  };

  const onLoad = () => {
    //np op
  };


  const { open, ready } = usePlaidLink({
    token: token,
    receivedRedirectUri: window.location.href,
    onSuccess,
    onExit,
    onEvent,
    onLoad
  });

  React.useEffect(() => {
    if (ready) {
      open();
    }
  }, [ready, open]);

  return (
      
    <div>
    {!ready &&
      <LoadingSpinner/>
    }
  </div>
  );

};



export default (ACHFormIIPlaidOAuth);